(function () {
  var LOG = '[easify-bridge]';

  // Called with each newly-inserted variant-picker (Primavera's viewTransition inserts
  // a sibling rather than mutating the existing element). When the Colour option that
  // Shopify resolved is marked unavailable for the new Profile/Finish combo, find the
  // first available Colour and fire a change so Primavera re-fetches the correct variant.
  function autoCorrectColour(variantPicker) {
    var colourSelect = variantPicker.querySelector('select[name="options[Colour]"]');
    if (!colourSelect) return;

    var currentSelected = colourSelect.querySelector('option[selected]');
    if (!currentSelected || !currentSelected.hasAttribute('data-unavailable')) return;

    for (var i = 0; i < colourSelect.options.length; i++) {
      var opt = colourSelect.options[i];
      if (opt.value && !opt.hasAttribute('data-unavailable')) {
        console.log(LOG, 'autoCorrectColour: correcting Colour to', opt.value);
        colourSelect.value = opt.value;
        colourSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  // Watch the variant-picker's parent for newly inserted variant-picker siblings
  // (viewTransition pattern). Run autoCorrectColour on each new one.
  function watchVariantPicker() {
    var vp = document.querySelector('variant-picker');
    if (!vp) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].localName === 'variant-picker') {
            console.log(LOG, 'new variant-picker inserted — running autoCorrectColour');
            autoCorrectColour(added[j]);
          }
        }
      }
    });

    observer.observe(vp.parentNode, { childList: true });
    console.log(LOG, 'watching', vp.parentNode.tagName, 'for VP replacements');
  }

  // Easify's useVariantObserver watches #fliplab-easify-bridge-input (registered via
  // TPOCustomFunctions in product.liquid). Setting its 'value' attribute triggers Easify's
  // MutationObserver → debounces 200 ms → reads new FormData(form).get("id") → calls
  // setSelectedVariant → condition rules re-evaluate → option sets show/hide correctly.
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    console.log(LOG, 'variant:change — signalling Easify with variant', v.id, v.title);
    var bridge = document.getElementById('fliplab-easify-bridge-input');
    if (bridge) bridge.setAttribute('value', String(v.id));
  });

  window.addEventListener('load', function () {
    setTimeout(watchVariantPicker, 300);
  });

  console.log(LOG, 'loaded');
})();
